import React from "react";
import "../styles/eventDetails.css";
import LaunchCounter from "./counters";
import TimeLine from "./Timeline";
import Sponsors from "./currentSponsors";
import App from "./judges";
import Prizepool from "./prizepool";
import im from "./Images/gvlogo.png";
const upcomingEvent = () => {
  const event = {
    description: `
      <h2>Event Description:</h2>
      <p>Join us for the much-awaited <strong>GeekVishwa 2.0</strong> hackathon! This exciting event will bring together
      innovative minds to solve real-world problems across multiple domains.</p>
      <h3>Event Timeline:</h3>
      <TimeLine />
      <h2>Round 1 - PPT Presentation (14 January)</h2>
    <ul>
      <li>All teams must submit a PPT based on the provided template by 11:59 PM 14th January.</li>
      <li>Judging panel reviews the presentations and shortlists 40 teams based on specified criteria (innovation, business viability, understanding).</li>
      <li>Shortlisted teams are notified on the evening of 16th January.</li>
    </ul>
    <h2>Round 2 - Prototype Presentation Round (20 January)</h2>
    <h3>First Session (10:00 AM - 12:30 PM)</h3>
    <ul>
      <li>Be prepared to present your project if you're in the first batch of 20 teams. Each team gets 5 minutes to present and 2 minutes for Q&A with judges.</li>
    </ul>

    <h3>Second Session (1:30 PM - 4:30 PM)</h3>
    <ul>
      <li>The next batch of teams will present after the introduction of the new judges panel.</li>
    </ul>
      <h2>Judging Criteria:</h2>
      <p>Judges will evaluate projects based on:</p>
      <ul>
        <li>Business Viability</li>
        <li>Innovation</li>
        <li>Understanding of Problem Statement</li>
        <li>Scalability</li>
      </ul>
    `,
  };

  return (
    <>
      <div id="main1">
        <div id="content-wrapper">
          <div id="event-name">
            <h1 className="mainheading">{event.name}</h1>
          </div>
          <div id="poster">
            <div id="event-image">
              <img src={im} alt="Event Poster" />
            </div>
{/*             <LaunchCounter /> */}

            <div id="event-details">
              <div>
                <button
                  type="button"
                  style={{ padding: "1.25rem 3rem" }}
                  onClick={() => {
                    window.location =
                      "https://unstop.com/p/geekvishwa-20-gfg-student-chapter-viit-1363822";
                  }}
                >
                  Register
                </button>
              </div>
            </div>
          </div>
          <div id="description">
            <TimeLine />

            <div />
          </div>
          <div>
            <Prizepool />
          </div>
          <div>
            <App />
          </div>
          <div>
            <Sponsors />
          </div>
        </div>
      </div>
    </>
  );
};

export default upcomingEvent;
